import React from "react";
const ActualLoadingTable = ({ cmtWagons, otherWagons, data }) => {
  return (
    <div>
      {" "}
      <div className="card-body bg-light">
        <div className="table-responsive newUiTable">
          <table className="table">
            <thead className="align-middle">
              <tr>
                <th
                  className="border-end"
                  colSpan={cmtWagons.length > 0 ? cmtWagons.length + 1 : 1}
                  rowSpan={cmtWagons.length === 0 && 0}
                >
                  CEMENT
                </th>

                <th
                  className="border-end"
                  colSpan={otherWagons.length > 0 ? otherWagons.length + 1 : 1}
                  rowSpan={otherWagons.length === 0 && 0}
                >
                  OTHER THEN CEMENT
                </th>
                <th rowSpan={2}>GRAND TOTAL</th>
              </tr>
              <tr>
                {cmtWagons.map((m, j) => {
                  return <th key={j}>{m}</th>;
                })}{" "}
                {cmtWagons.length > 0 && <th className="border-end">Total</th>}
                {otherWagons.map((m, k) => {
                  return <th key={k}>{m}</th>;
                })}
                {otherWagons.length > 0 && (
                  <th className="border-end">Total</th>
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                {cmtWagons.map((m, j) => {
                  return (
                    <td className="px-3 fw-bold text-dark" key={j}>
                      {data.cementCount[m]}
                    </td>
                  );
                })}{" "}
                <td className="px-3 fw-bold text-dark border-end">
                  {data.totalCementWagonsType}
                </td>
                {otherWagons.map((m, k) => {
                  return (
                    <td className="px-3 fw-bold text-dark" key={k}>
                      {data.otherCount[m]}
                    </td>
                  );
                })}
                <td className="px-3 fw-bold text-dark border-end">
                  {data.totalOtherWagonsType}
                </td>
                <td className="px-3 fw-bold text-dark">
                  {" "}
                  {data.totalCementWagonsType + data.totalOtherWagonsType}
                </td>
              </tr>{" "}
              <tr>
                {cmtWagons.map((m, j) => {
                  return (
                    <td className="px-3 fw-bold text-dark" key={j}>
                      {data.cement[m]}
                    </td>
                  );
                })}{" "}
                <td className="px-3 fw-bold text-dark border-end">
                  {data.totalCementRakes}
                </td>
                {otherWagons.map((m, k) => {
                  return (
                    <td className="px-3 fw-bold text-dark" key={k}>
                      {data.other[m]}
                    </td>
                  );
                })}
                <td className="px-3 fw-bold text-dark border-end">
                  {data.totalOtherRakes}
                </td>
                <td className="px-3 fw-bold text-dark">
                  {" "}
                  {data.totalCementRakes + data.totalOtherRakes}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default ActualLoadingTable;
